import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import axios from "axios";
import tw from "tailwind-styled-components";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import Navbar from "../../Components/Navbar";
import Images from "../../Images";
import { t } from "i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Label, SubmitBtn } from "../../Components/Styles/InputStyles";
import { Checkbox, ListItemText } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

const propertyCategoryOptions = [
  { value: "Co-Living", label: "Co-Living" },
  { value: "Family Home", label: "Family Home" },
  { value: "Paying Guest House", label: "Paying Guest House" },
  { value: "Serviced Apartment", label: "Serviced Apartment" },
];

const noOfBathrooms = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
];
const No_of_Bedrooms = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
];
const propertyAge = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
];

const propertyTypeOptions = [
  { value: "Apartment", label: "Apartment" },
  { value: "Studio", label: "Studio" },
  { value: "Builder floor", label: "Builder floor" },
  { value: "Villa", label: "Villa" },
  { value: "Bunglow", label: "Bunglow" },
  { value: "Independent House", label: "Independent House" },
  { value: "Bunk Bed", label: "Bunk Bed" },
  { value: "Private Room", label: "Private Room" },
  { value: "Double Shared", label: "Double Shared" },
  { value: "Triple Shared", label: "Triple Shared" },
];

const amenitiesOptions = [
  { value: "Wi-Fi", label: "Wi-Fi" },
  { value: "Geyser", label: "Geyser" },
  { value: "Balcony", label: "Balcony" },
  { value: "TV", label: "TV" },
  { value: "Attached Bathroom", label: "Attached Bathroom" },
  { value: "AC", label: "AC" },
  { value: "Cooler", label: "Cooler" },
  { value: "Washing Machine", label: "Washing Machine" },
];

const states = [
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CT", label: "Chhattisgarh" },
  { value: "DL", label: "Delhi" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OD", label: "Odisha" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TG", label: "Telangana" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "CH", label: "Chandigarh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "PY", label: "Puducherry" },
];

const validationSchema = Yup.object().shape({
  ownerFullName: Yup.string().required("Required"),
  servantRoom: Yup.boolean().required("Required"),
  studyRoom: Yup.boolean().required("Required"),

  expectedRent: Yup.number().required("Required").positive(),
  expectedBondValue: Yup.number().required("Required").positive(),
  expectedAdvanceRent: Yup.number().required("Required").positive(),

  propertyAddress: Yup.object().shape({
    addressType: Yup.string().required("Required"),
    street: Yup.string().required("Required"),
    locality: Yup.string().required("Required"),
    house: Yup.string().required("Required"),
    city: Yup.string().required("Required"),

    pin: Yup.string()
      .required("Required")
      .matches(/^\d{6}$/, "Must be exactly 6 digits"),
  }),

  productId: Yup.string().required("Required"),
  bondFees: Yup.string().required("Required"),
  bondAmount: Yup.string().required("Required"),
});

const PropertyForm = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const { clientId } = useParams();
  const { propId } = useParams();
  const navigate = useNavigate();
  const [selectedPropertyId, setSelectedPropertyId] = useState("");

  const InitialValues = {
    name: "",
    propertyType: "",
    No_of_Bedrooms: "",
    ownerFullName: "",
    propertyCategory: "",
    servantRoom: false,
    studyRoom: false,
    noOfBathrooms: "",

    expectedRent: "",
    expectedBondValue: "",
    expectedAdvanceRent: "",
    propertyAge: "",

    propertyAddress: {
      addressType: "current",
      street: "",
      locality: "",
      house: "",
      city: "",
      state: "",
      pin: "",
    },
    amenities: [],
    productId: "",
    bondFees: "",
    bondAmount: "",
  };

  const fetchProperties = async () => {
    const body = new FormData();
    body.append("clientId", clientId);

    return await axios.post(`${Config.apiUrl}/getproperties`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getPropertiesSuccess = (res) => {};

  const getPropertiesError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getPropertiesMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchProperties, {
    onSuccess: getPropertiesSuccess,
    onError: getPropertiesError,
  });

  useEffect(() => {
    getPropertiesMutate();
  }, []);

  const handlePropertyChange = (event, setFieldValue) => {
    const selectedId = event.target.value;
    setFieldValue("property", selectedId);
    setSelectedPropertyId(selectedId);
  };

  const addPropertyEqaro = async (values) => {
    const body = new FormData();
    body.append("name", values.name);
    body.append("propId", values.id);
    body.append("No_of_Bedrooms", values.No_of_Bedrooms);
    body.append("ownerFullName", values.ownerFullName);
    body.append("noOfBathrooms", values.noOfBathrooms);
    body.append("expectedRent", values.expectedRent);
    body.append("expectedBondValue", values.expectedBondValue);
    body.append("expectedAdvanceRent", values.expectedAdvanceRent);
    body.append("propertyAge", values.propertyAge);
    body.append("productId", values.productId);
    body.append("bondFees", values.bondFees);
    body.append("bondAmount", values.bondAmount);
    body.append("studyRoom", values.studyRoom);
    body.append("servantRoom", values.servantRoom);
    body.append("addressType", "current");
    body.append("street", values.propertyAddress.street);
    body.append("locality", values.propertyAddress.locality);
    body.append("house", values.propertyAddress.house);
    body.append("city", values.propertyAddress.city);
    body.append("state", values.propertyAddress.state);
    body.append("pin", values.propertyAddress.pin);
    values.amenities.forEach((amenity, index) => {
      body.append(`amenities[${index}]`, amenity);
    });
    body.append("propertyCategory", values.propertyCategory);
    body.append("propertyType", values.propertyType);

    return await axios.post(`${Config.apiUrl}/eqarocreateproperty`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getPropertySuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(
        data?.data?.msg || "Property successfully linked with eqaro."
      );
      navigate(-1);
    }
  };

  const getTenantsError = (res) => {};

  const { isLoading: isPropertyLoading, mutate: addPropertyMutate } =
    useMutation(addPropertyEqaro, {
      onSuccess: getPropertySuccess,
      onError: getTenantsError,
    });

  const SubmitHandler = (values, { setSubmitting }) => {
    if (!values.amenities || values.amenities.length === 0) {
      toast.error("Amenities are required.");
      setSubmitting(false);
      return;
    }

    if (!values.propertyType) {
      toast.error("Property Type is required.");
      setSubmitting(false);
      return;
    }

    if (!values.propertyCategory) {
      toast.error("Property Category is required.");
      setSubmitting(false);
      return;
    }
    if (!values.noOfBathrooms) {
      toast.error("Bathroom selection is required.");
      setSubmitting(false);
      return;
    }
    if (!values.No_of_Bedrooms) {
      toast.error("Bedroom selection is required.");
      setSubmitting(false);
      return;
    }
    if (!values.propertyAge) {
      toast.error("Property Age is required.");
      setSubmitting(false);
      return;
    }
    if (!values.propertyAddress.state) {
      toast.error("State is required.");
      setSubmitting(false);
      return;
    }
    const { id, name } = values.name;
    const formattedValues = {
      ...values,
      id,
      name,
      amenities: values.amenities,
      propertyCategory: values.propertyCategory,
      propertyType: values.propertyType,
      noOfBathrooms: values.noOfBathrooms,
      No_of_Bedrooms: values.No_of_Bedrooms,
      propertyAge: values.propertyAge,
      state: values.propertyAddress.state,
    };
    addPropertyMutate(formattedValues);
    setSubmitting(false);
  };

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Register Property")}</Title>
              <Underline />
            </div>
          </div>
          <div className=" mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl">
            <Formik
              initialValues={InitialValues}
              validationSchema={validationSchema}
              onSubmit={SubmitHandler}
            >
              {({
                isSubmitting,
                setFieldValue,
                setFieldTouched,
                errors,
                touched,
                values,
              }) => (
                <Form className="space-y-6 ">
                  <div>
                    <h3 className="text-lg font-medium mb-2">Basic Details</h3>
                    <div className="space-y-4">
                      <TwoCol>
                        <div>
                          <Label htmlFor="name">Property Name</Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="name"
                            value={values.name?.name || ""}
                            onChange={(event, child) => {
                              const selectedOption = data.data.data.find(
                                (item) => item.name === child.props.value
                              );
                              setFieldValue("name", {
                                id: selectedOption?.id,
                                name: selectedOption?.name,
                              });
                            }}
                            classnameprefix="select"
                            displayEmpty
                          >
                            {data?.data?.data && data.data.data.length > 0
                              ? data.data.data.map((item) => (
                                  <MenuItem key={item.id} value={item.name}>
                                    {item.name || "Unnamed Property"}
                                  </MenuItem>
                                ))
                              : ""}
                          </Select>

                          {errors.property && touched.property && (
                            <ErrorText>{errors.property}</ErrorText>
                          )}
                        </div>

                        <div>
                          <Label htmlFor="ownerFullName">Owner Full Name</Label>
                          <Field name="ownerFullName" as={Input} type="text" />
                          <ErrorMessage
                            name="ownerFullName"
                            component={ErrorText}
                          />
                        </div>
                      </TwoCol>
                      <TwoCol>
                        <div>
                          <Label htmlFor="propertyType">Property Type</Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="propertyType"
                            value={values.propertyType}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue("propertyType", event.target.value)
                            }
                          >
                            {propertyTypeOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.propertyType && touched.propertyType && (
                            <ErrorText>{errors.propertyType}</ErrorText>
                          )}
                        </div>

                        <div>
                          <Label htmlFor="propertyCategory">
                            Property Category
                          </Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="propertyCategory"
                            value={values.propertyCategory}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue(
                                "propertyCategory",
                                event.target.value
                              )
                            }
                          >
                            {propertyCategoryOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.propertyCategory &&
                            touched.propertyCategory && (
                              <ErrorText>{errors.propertyCategory}</ErrorText>
                            )}
                        </div>
                      </TwoCol>

                      <TwoCol>
                        <div>
                          <Label>Servant Room</Label>
                          <RadioGroup className="flex items-center gap-4 mt-2">
                            <label className="flex items-center gap-2">
                              <Field
                                type="radio"
                                name="servantRoom"
                                value="true"
                                className="form-radio"
                              />
                              Yes
                            </label>
                            <label className="flex items-center gap-2">
                              <Field
                                type="radio"
                                name="servantRoom"
                                value="false"
                                className="form-radio"
                              />
                              No
                            </label>
                          </RadioGroup>
                          <ErrorMessage
                            name="servantRoom"
                            component={ErrorText}
                          />
                        </div>

                        <div>
                          <Label>Study Room</Label>
                          <RadioGroup className="flex items-center gap-4 mt-2">
                            <label className="flex items-center gap-2">
                              <Field
                                type="radio"
                                name="studyRoom"
                                value="true"
                                className="form-radio"
                              />
                              Yes
                            </label>
                            <label className="flex items-center gap-2">
                              <Field
                                type="radio"
                                name="studyRoom"
                                value="false"
                                className="form-radio"
                              />
                              No
                            </label>
                          </RadioGroup>
                          <ErrorMessage
                            name="studyRoom"
                            component={ErrorText}
                          />
                        </div>
                      </TwoCol>

                      <ThreeCol>
                        <div>
                          <Label htmlFor="noOfBathrooms">
                            Number of Bathrooms
                          </Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="noOfBathrooms"
                            value={values.noOfBathrooms}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue("noOfBathrooms", event.target.value)
                            }
                          >
                            {noOfBathrooms.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.noOfBathrooms && touched.noOfBathrooms && (
                            <ErrorText>{errors.noOfBathrooms}</ErrorText>
                          )}
                        </div>
                        <div>
                          <Label htmlFor="No_of_Bedrooms">
                            Number of Bedrooms
                          </Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="No_of_Bedrooms"
                            value={values.No_of_Bedrooms}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue(
                                "No_of_Bedrooms",
                                event.target.value
                              )
                            }
                          >
                            {No_of_Bedrooms.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.No_of_Bedrooms && touched.No_of_Bedrooms && (
                            <ErrorText>{errors.No_of_Bedrooms}</ErrorText>
                          )}
                        </div>
                        <div>
                          <Label htmlFor="propertyAge">Property Age</Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="propertyAge"
                            value={values.propertyAge}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue("propertyAge", event.target.value)
                            }
                          >
                            {propertyAge.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.propertyAge && touched.propertyAge && (
                            <ErrorText>{errors.propertyAge}</ErrorText>
                          )}
                        </div>
                      </ThreeCol>
                      <ThreeCol>
                        <div>
                          <Label htmlFor="expectedRent">
                            Expected Rent (₹)
                          </Label>
                          <Field
                            name="expectedRent"
                            as={Input}
                            type="text"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                          />
                          <ErrorMessage
                            name="expectedRent"
                            component={ErrorText}
                          />
                        </div>

                        <div>
                          <Label htmlFor="expectedBondValue">
                            Expected Bond Value (₹)
                          </Label>
                          <Field
                            name="expectedBondValue"
                            as={Input}
                            type="text"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                          />
                          <ErrorMessage
                            name="expectedBondValue"
                            component={ErrorText}
                          />
                        </div>

                        <div>
                          <Label htmlFor="expectedAdvanceRent">
                            Expected Advance Rent (₹)
                          </Label>
                          <Field
                            name="expectedAdvanceRent"
                            as={Input}
                            type="text"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                          />
                          <ErrorMessage
                            name="expectedAdvanceRent"
                            component={ErrorText}
                          />
                        </div>
                      </ThreeCol>

                      <div>
                        <Label htmlFor="amenities">Amenities</Label>
                        <Select
                          multiple
                          value={values.amenities}
                          className="w-full pl-2 mt-1"
                          classnameprefix="select"
                          name="amenities"
                          onChange={(event) =>
                            setFieldValue("amenities", event.target.value)
                          }
                          renderValue={(selected) => selected.join(", ")}
                        >
                          {amenitiesOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              <Checkbox
                                className=" h-4 w-4"
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 19,
                                  },
                                }}
                                checked={values.amenities?.includes(
                                  option.value
                                )}
                              />
                              <ListItemText
                                className="pl-2 text-base"
                                primary={option.label}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.amenities && touched.amenities && (
                          <ErrorText>{errors.amenities}</ErrorText>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium mb-2">
                      Product Details
                    </h3>
                    <div className="space-y-4">
                      <ThreeCol>
                        <div>
                          <Label htmlFor="productId">Product ID</Label>
                          <Field name="productId" as={Input} type="text" />
                          <ErrorMessage
                            name="productId"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="bondFees">Bond Fees (₹)</Label>
                          <Field name="bondFees" as={Input} type="text" />
                          <ErrorMessage name="bondFees" component={ErrorText} />
                        </div>
                        <div>
                          <Label htmlFor="bondAmount">Bond Amount (₹)</Label>
                          <Field name="bondAmount" as={Input} type="text" />
                          <ErrorMessage
                            name="bondAmount"
                            component={ErrorText}
                          />
                        </div>
                      </ThreeCol>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium mb-2">
                      Property Address
                    </h3>
                    <div className="space-y-4">
                      <ThreeCol>
                        <div>
                          <Label htmlFor="propertyAddress.street">Street</Label>
                          <Field
                            name="propertyAddress.street"
                            as={Input}
                            type="text"
                          />
                          <ErrorMessage
                            name="propertyAddress.street"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="propertyAddress.locality">
                            Locality
                          </Label>
                          <Field
                            name="propertyAddress.locality"
                            as={Input}
                            type="text"
                          />
                          <ErrorMessage
                            name="propertyAddress.locality"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="propertyAddress.house">House</Label>
                          <Field
                            name="propertyAddress.house"
                            as={Input}
                            type="text"
                          />
                          <ErrorMessage
                            name="propertyAddress.house"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="propertyAddress.city">City</Label>
                          <Field
                            name="propertyAddress.city"
                            as={Input}
                            type="text"
                          />
                          <ErrorMessage
                            name="propertyAddress.city"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="propertyAddress.pin">PIN Code</Label>
                          <Field
                            name="propertyAddress.pin"
                            as={Input}
                            type="text"
                          />
                          <ErrorMessage
                            name="propertyAddress.pin"
                            component={ErrorText}
                          />
                        </div>
                        <div>
                          <Label htmlFor="propertyAddress.state">State</Label>
                          <Select
                            className="w-full pl-2 mt-1"
                            name="state"
                            value={values.propertyAddress.state}
                            classnameprefix="select"
                            onChange={(event) =>
                              setFieldValue(
                                "propertyAddress.state",
                                event.target.value
                              )
                            }
                          >
                            {states.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.propertyAddress?.state &&
                            touched.propertyAddress?.state && (
                              <ErrorText>
                                {errors.propertyAddress.state}
                              </ErrorText>
                            )}
                        </div>
                      </ThreeCol>
                    </div>
                  </div>

                  <BtnWrapper>
                    <SubmitBtn
                      type="submit"
                      disabled={isSubmitting || isPropertyLoading}
                    >
                      {isPropertyLoading ? "Submitting..." : "Submit"}
                    </SubmitBtn>
                  </BtnWrapper>
                </Form>
              )}
            </Formik>
          </div>
        </BoxContainer>
      </Bg>
    </>
  );
};

const ThreeCol = tw.div`grid md:grid-cols-3 grid-col-1 gap-4`;
const TwoCol = tw.div`grid md:grid-cols-2 grid-col-1 gap-4`;
const Input = tw.input`mt-1 pl-2 block w-full rounded border border-m border-gray-400 focus:border-sky-600 focus:ring-1 focus:ring-sky-600 focus:ring-opacity-50 focus:outline-none duration-200`;
// const Label = tw.label`block text-sm font-medium text-gray-500`;
const Button = tw.button`mt-4 px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`;
const ErrorText = tw.div` text-red-500 text-sm mt-1`;
const RadioGroup = tw.div`mt-2 space-x-10 flex items-center`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap font-medium`;
const BtnWrapper = tw.div`w-full flex items-center justify-end space-x-10`;
export default PropertyForm;
